import { IKnoLevel } from '../../../APIPackage/CatalogsModule/interfaces/IKnoLevel';
import { IKnoLevelSelectOption } from '../interfaces/IKnoLevelSelectOption';

export const createKnoLevelSelectOption = (knoAdminLevel: IKnoLevel): IKnoLevelSelectOption => ({
  ...knoAdminLevel,
  label: knoAdminLevel.name,
  value: knoAdminLevel.code,
});
